import { dataFolderStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderStar = /*#__PURE__*/createIcon(dataFolderStar)
export default IconFolderStar
